import { Container, Row, Col, Nav } from "react-bootstrap";
import { CookieBanner } from "@palmabit/react-cookie-law";

import brainyImg from "../assets/img/brainy.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  return (
    <>
      <section className="banner" id="home">
        <Container>
          <CookieBanner
            message="We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below.
            The cookies that are categorized as 'Necessary' are stored on your browser as they are essential for enabling the basic functionalities of the site.            
            We also use third-party cookies that help us analyze how you use this website, store your preferences, and provide the content and advertisements that are relevant to you. These cookies will only be stored in your browser with your prior consent.            
            You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience."
            wholeDomain={true}
            onAccept={() => {}}
            onAcceptPreferences={() => {}}
            onAcceptStatistics={() => {}}
            onAcceptMarketing={() => {}}
            policyLink={"https://epistum.com/privacy-policy/"}
            preferencesOptionText={"Functional"}
            marketingOptionText={"Advertisement"}
            statisticsOptionText={"Performance"}
            preferencesDefaultChecked={true}
            marketingDefaultChecked={true}
            statisticsDefaultChecked={true}
          />
          <Row className="aligh-items-center">
            <Col xs={12} md={6} xl={7}>
              <TrackVisibility once>
                {({ isVisible }) => (
                  <div
                    className={
                      isVisible ? "animate__animated animate__fadeInUp" : ""
                    }
                  >
                    <h1>SEE WHAT WE BUILD</h1>
                    <p className="mainLine">
                      Portfolio of some of the recent Corporate E-Learning
                      projects
                    </p>

                    <br></br>

                    <p className="text">
                      E-course Development <br></br>
                      <br></br>Whether it’s helping frame your learning
                      strategy, building an entire curriculum, or converting
                      existing training, we’ll be your extra set of hands in
                      developing eLearning that ROCKS!
                    </p>
                  </div>
                )}
              </TrackVisibility>
            </Col>
            <Col xs={12} md={6} xl={5}>
              <TrackVisibility once>
                {({ isVisible }) => (
                  <div
                    className={
                      isVisible
                        ? "animate__animated animate__backInRight"
                        : "d-none"
                    }
                  >
                    <img src={brainyImg} alt="Brainy Img" />
                    <a className="linkTalk" href="mailto:contact@epistum.mk">
                      <button className="btn-talk">
                        <span> Let's Talk</span>
                      </button>
                    </a>
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
